import angular from 'angular';

import HeaderNavCtrl from './header-nav.controller';
import UserModel from '../../models/user';

function HeaderNav(CurrentUser) {
  return {
    restrict: 'E',
    template: require('./header-nav.html'),
    controller: HeaderNavCtrl,
    link: function (scope, element, attrs) {
      scope.user = CurrentUser.data;
      scope.userMenu = attrs.userMenu; // bool
      scope.links = attrs.links; // bool
      // may include 'signup' and 'signin'
      scope.headerNavClass = attrs.headerNavClass;
      scope.setActions(
        attrs.actions && attrs.actions.split(' ')
      );

    }
  };
}
HeaderNav.$inject = ['CurrentUser'];

export default angular.module('directives.header-nav', [UserModel])
  .directive('headerNav', HeaderNav)
  .name;



// WEBPACK FOOTER //
// ./project/directives/header-nav/index.js